"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ChargeCounts = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var pluralize_1 = __importDefault(require("pluralize"));
var DEFAULT_PROPS = {
    counts: {
        procedures: 0,
        diagnosis: 0,
        modifiers: 0
    }
};
var ChargeCounts = function (props) {
    var appliedProps = __assign(__assign({}, DEFAULT_PROPS), props);
    var counts = appliedProps.counts, rest = __rest(appliedProps, ["counts"]);
    var hasProcedures = counts.procedures > 0;
    var hasDX = counts.diagnosis > 0;
    var hasMods = counts.modifiers > 0;
    var styleClasses = [
        'charge-counts',
        {
            'has-procedures': hasProcedures,
            'has-dx': hasDX,
            'has-mods': hasMods
        }
    ];
    var itemTypes = [hasProcedures, hasDX, hasMods].filter(function (item) { return item; }).length;
    var readout = [];
    if (hasProcedures) {
        readout.push("".concat(counts.procedures, " ").concat((0, pluralize_1["default"])('procedure', counts.procedures)));
    }
    if (hasDX) {
        var dxString = counts.diagnosis === 1
            ? "".concat(counts.diagnosis, " diagnosis")
            : "".concat(counts.diagnosis, " diagnoses");
        readout.push(dxString);
    }
    if (hasMods) {
        var slug = readout.length === 2 ? 'and ' : '';
        readout.push("".concat(slug).concat(counts.modifiers, " ").concat((0, pluralize_1["default"])('modifier', counts.modifiers)));
    }
    var summary = '';
    if (readout.length === 0) {
        summary = 'No codes assigned';
    }
    else if (readout.length === 1) {
        summary = readout.join('');
    }
    else if (readout.length === 2) {
        summary = readout.join(' and ');
    }
    else {
        summary = readout.join(', ');
    }
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, rest, { className: (0, classnames_1["default"])(styleClasses) }, { children: summary })));
};
exports.ChargeCounts = ChargeCounts;
ChargeCounts.displayName = 'ChargeCounts';
//# sourceMappingURL=charge-counts.js.map